export const ENCRYPTION_ALGORITHM = 'AES-GCM';
export const PREFIX_ENCRYPTED_CONTENT = '[[-ENC-]]';
export const PREFIX_ENCRYPTED_CONTENT_LEGACY = '[[-AES-]]';
